const localeContext = require.context('../../i18n/pt', false, /\.json$/)
const sharedContext = require.context('../../i18n', false, /cross_locale\.json$/)

window.HCM_I18N_TRANSLATIONS = [localeContext, sharedContext].flatMap((context) => context.keys().map((key) => context(key)))
window.HCM_DATE_FNS_LOCALES = { pt: require('date-fns/locale/pt').pt }
